import { assert } from '../../../app/logger.js';
import { MarkerBaseMixin } from '../base/marker_base_mixin.js';
import { LayerGoogleMaps } from './layer_googlemaps.js';

/**
 * A wrapper around GoogleMaps marker.
 */
class MarkerGoogleMaps extends MarkerBaseMixin(LayerGoogleMaps) {
  static Standard(options) {
    return new MarkerGoogleMaps(
      Object.assign(
        {
          icon: '',
          get animation() {
            return window.google.maps.Animation.DROP;
          },
        },
        options
      )
    );
  }

  get title() {
    return this.native.getTitle();
  }

  set title(v) {
    this.native.setTitle(v);
  }

  get position() {
    let p = this.native.getPosition();
    return (
      (p && {
        lat: p.lat(),
        lng: p.lng(),
      }) ||
      null
    );
  }

  set position(v) {
    let pos = new window.google.maps.LatLng(v.lat, v.lng);
    this.native.setPosition(pos);
  }

  get draggable() {
    return this.native.getDraggable();
  }

  set draggable(v) {
    this.native.setDraggable(v);
  }

  get icon() {
    return this.native.getIcon();
  }

  set icon(v) {
    this.native.setIcon(this.getNativeOption('icon', v));
  }

  on(eventName, listener) {
    assert(
      this.native.getClickable(),
      `[map:googlemaps] setting event listener for not clickable marker`
    );
    return super.on(eventName, listener);
  }

  // Protected

  createNative() {
    return new window.google.maps.Marker(this.nativeOptions);
  }

  static get nativeOptionsMapper() {
    return Object.assign({}, super.nativeOptionsMapper, {
      animation: 'animation',
      label: 'label',
      icon: icon => {
        if (!icon) {
          return '';
        }
        let gicon = {};
        if (icon.url) {
          gicon.url = icon.url;
        }
        if (icon.size) {
          gicon.scaledSize = new window.google.maps.Size(
            icon.size.width,
            icon.size.height
          );
        }
        if (icon.anchor) {
          gicon.anchor = new window.google.maps.Point(
            icon.anchor.x,
            icon.anchor.y
          );
        }
        return gicon;
      },
      position: 'position',
      title: 'title',
    });
  }
}

export { MarkerGoogleMaps };
